import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export default function SvgIconX({
	className,
	...props
} : SvgIconProps) {
	return (
		<SvgIcon
			className={cn(styles.SvgIconX, className)}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.30321 1.2996C3.03602 -0.433201 5.84545 -0.433201 7.57826 1.2996L50 43.7213L92.4217 1.2996C94.1546 -0.433201 96.964 -0.433201 98.6968 1.2996C100.43 3.03241 100.43 5.84184 98.6968 7.57465L56.275 49.9964L98.7004 92.4217C100.433 94.1546 100.433 96.964 98.7004 98.6968C96.9676 100.43 94.1582 100.43 92.4254 98.6968L50 56.2714L7.57465 98.6968C5.84184 100.43 3.03241 100.43 1.2996 98.6968C-0.433201 96.964 -0.433201 94.1546 1.2996 92.4217L43.725 49.9964L1.30321 7.57465C-0.429591 5.84184 -0.429591 3.03241 1.30321 1.2996Z"
			/>
		</SvgIcon>
	)
}
